<tran-ui-content-section backgroundColor="light-sand">
    <div class="flex gap-1">
        @for (item of navigationItems(); track item.label) {
            <tran-tertiary-button [label]="item.label" (clicked)="scrollToSection(item.route)" />
        }
    </div>
</tran-ui-content-section>
